import { useCallback } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { ignoreUndoRedoHotkey as shouldIgnoreMotionEditorHotkey } from '../utils';
import { useStore } from './repathingStore';

interface UseRepathingHotkeysOptions {
  enabled?: boolean;
}

export function useRepathingHotkeys({
  enabled = true,
}: UseRepathingHotkeysOptions = {}) {
  const store = useStore();
  const { actionStack, controlsMode, dragging, generation } = store.state;
  const hotkeysEnabled =
    enabled &&
    controlsMode === 'path' &&
    !dragging &&
    generation.status !== 'pending';
  const canUndo = hotkeysEnabled && actionStack.index >= 0;
  const canRedo =
    hotkeysEnabled && actionStack.index < actionStack.entries.length - 1;

  const undo = useCallback(() => {
    store.undoAction();
  }, [store]);

  const redo = useCallback(() => {
    store.redoAction();
  }, [store]);

  useHotkeys(
    'meta+z, ctrl+z',
    undo,
    {
      enabled: canUndo,
      ignoreEventWhen: shouldIgnoreMotionEditorHotkey,
      preventDefault: true,
    },
    [undo],
  );

  useHotkeys(
    'meta+shift+z, ctrl+shift+z, ctrl+y',
    redo,
    {
      enabled: canRedo,
      ignoreEventWhen: shouldIgnoreMotionEditorHotkey,
      preventDefault: true,
    },
    [redo],
  );
}
